import React from "react";
import "../styles/Dashboard.css";

const Card = ({ title, value, subtext, icon }) => {
  return (
    <div className="dashboard-card">
      <div className="cards-header">
        <h3 className="card-title">{title}</h3>{" "}
        {icon && <div className="card-icon">{icon}</div>}
      </div>
      <p className="card-value">{value}</p>
      <p className="card-subtext">{subtext}</p>
    </div>
  );
};

export default Card;
